// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (c) 2026 Password Manager contributors
import { createFileRoute } from "@tanstack/react-router";
import { PlanInviteClaimPage } from "@/components/billing/PlanInviteClaimPage";

export const Route = createFileRoute("/invite/$token")({
  component: InviteRoute,
});

function InviteRoute() {
  const { token } = Route.useParams();
  return <PlanInviteClaimPage token={token} />;
}
